import { requiredMessage } from "../utils/common";
import luhn from "fast-luhn"; // https://github.com/sumup/circuit-ui/blob/d0b22c6b49b6168d1e682719b66b3d56dbe2610e/src/components/CreditCardDetails/components/CardNumberInput/constants/validation-regexes.js
var VALIDATION_REGEXES = {
  VISA: /^4\d{12}(?:\d{3})?$/,
  MASTERCARD: /^(?:2(?:2(?:2[1-9]\d{2}|[3-9]\d{3})|[3-6]\d{4}|7(?:[0-1]\d{3}|20\d{2}))|5[1-5]\d{4})\d{10}$/,
  AMEX: /^3[47]\d{13}$/
};
function isValidCardOfSupportedType(number) {
  var validType = false;
  Object.keys(VALIDATION_REGEXES).forEach(function (item) {
    if (VALIDATION_REGEXES[item].test(number)) {
      validType = true;
    }
  });
  return validType;
}
function isCreditCardValid(number) {
  var numbersOnly = number.replace(/[\s_]/g, "");
  var valid = luhn(numbersOnly);
  if (valid) {
    return isValidCardOfSupportedType(numbersOnly);
  }
  return false;
}
var validCreditCardNumber = function validCreditCardNumber(value) {
  var error; // eslint-disable-line init-declarations
  if (!value) {
    error = requiredMessage("card number");
  } else if (!isCreditCardValid(value)) {
    error = "Please enter a valid credit card number.";
  }
  return error;
};
export default validCreditCardNumber;